<template>
  <div class="notification-container">
    <h2>Trimite Notificare Push (Mobil)</h2>
    <p>
      Acest formular va trimite o notificare push către TOATE dispozitivele mobile
      care au instalat aplicația și au permis notificările.
    </p>

    <form @submit.prevent="handleSubmit" class="notification-form">
      <div class="form-group">
        <label for="title">Titlu Notificare:</label>
        <input 
          type="text" 
          id="title" 
          v-model="form.title" 
          required 
          placeholder="Ex: Ședință Generală"
        />
      </div>
      
      <div class="form-group">
        <label for="message">Mesaj Notificare:</label>
        <textarea 
          id="message" 
          v-model="form.message" 
          required 
          rows="4"
          placeholder="Ex: Vă așteptăm Luni la ora 18:00 în sala..."
        ></textarea>
      </div>

      <button type="submit" :disabled="loading">
        {{ loading ? 'Se trimite...' : 'Trimite Notificarea' }}
      </button>
    </form>
    
    <div v-if="feedback" :class="['feedback', { 'error': isError }]">
      {{ feedback }}
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import apiClient from '@/api.js';

const form = ref({
  title: '',
  message: ''
});

const loading = ref(false);
const feedback = ref('');
const isError = ref(false);

const handleSubmit = async () => {
  if (!window.confirm('Ești sigur că vrei să trimiți această notificare către TOȚI utilizatorii?')) {
    return;
  }

  loading.value = true;
  feedback.value = '';
  isError.value = false;

  try {
    // Apelăm endpoint-ul pe care îl ai deja în API!
    const response = await apiClient.post('/admin/notifications/send-all', {
      title: form.value.title,
      message: form.value.message
    });

    feedback.value = response.data.message;
    isError.value = false;
    
    // Resetăm formularul
    form.value.title = '';
    form.value.message = '';

  } catch (err) {
    console.error("Eroare la trimiterea notificării:", err);
    feedback.value = `Eroare: ${err.response?.data?.error || 'A apărut o eroare.'}`;
    isError.value = true;
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped>
.notification-container {
  background-color: #fff;
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}

.notification-container h2 {
  color: #0E3035;
  margin-top: 0;
}

.notification-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.form-group label {
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box; /* Previne depășirea lățimii */
  font-size: 1em;
}

button {
  background-color: #C0392B; /* Roșu accent */
  color: white;
  padding: 12px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1em;
  font-weight: bold;
}
button:disabled {
  background-color: #ccc;
}

.feedback {
  margin-top: 20px;
  padding: 10px;
  border-radius: 4px;
  background-color: #e0f0e8;
  color: #27ae60;
}
.feedback.error {
  background-color: #f8d7da;
  color: #C0392B;
}
</style>